import RoleRewards from "@ugg/shared/components/Champions/pages/Overview/RoleRewards";
import RoleQuestRequirements from "@ugg/shared/components/Champions/pages/Overview/RoleQuestRequirements";
interface CommonProps extends RoleQuestProps {
  className?: string;
}
interface RoleQuestProps {
  champID: number;
  questTimer: string;
  role: string;
}

export default function RoleQuest(props: RoleQuestProps) {
  const { role, champID, questTimer } = props;

  return (
    <div className={`grid grid-cols-1 gap-[12px] mt-3 md:grid-cols-2 md:gap-[1px]`}>
      <RoleQuestRequirements role={role}></RoleQuestRequirements>
      <RoleRewards champID={champID} questTimer={questTimer} role={role}></RoleRewards>
    </div>
  );
}
